"use strict";
exports.__esModule = true;
exports.css = void 0;
exports.css = {
    root: '_1W83ZI2J',
    ' _key': 'base-widgets/icon'
};
exports["default"] = exports.css;
